// extracted by mini-css-extract-plugin
export default {"wrapper":"Portfolio_wrapper__4QAxX","rightSide":"Portfolio_rightSide__W4STN","forMobileAndTab":"Portfolio_forMobileAndTab__4lEtF"};